module.exports = __webpack_public_path__ + "static/media/padel.666eca84.jpeg";